import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';

import { CloseButtonComponent } from '../close-button/close-button.component';
import { IconName } from '../icons/auto-generated/icon-name';
import { IconComponent } from '../icons/icon.component';
import { fadeAnimation } from './fade-animation';

@Component({
  imports: [IconComponent, CloseButtonComponent],
  selector: 'mop-alert',
  template: `
    @if (show()) {
      <div [class]="cssClasses()" [@fadeAnimation] role="alert">
        <mop-icon [name]="iconName()" [outlined]="true"></mop-icon>
        <div>
          <ng-content></ng-content>
        </div>
        @if (closable()) {
          <mop-close-button (close)="close.emit()"></mop-close-button>
        }
      </div>
    }
  `,
  host: {
    class: 'd-block',
  },
  animations: [fadeAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent {
  type = input<'danger' | 'primary' | 'success' | 'warning'>('primary');
  closable = input(false, { transform: booleanAttribute });
  show = input(true, { transform: booleanAttribute });

  close = output();

  cssClasses = computed(() => {
    switch (this.type()) {
      case 'danger':
        return ['alert', 'alert-danger'];
      case 'success':
        return ['alert', 'alert-success'];
      case 'warning':
        return ['alert', 'alert-warning'];
      default:
        return ['alert', 'alert-primary'];
    }
  });

  iconName = computed<IconName>(() => {
    switch (this.type()) {
      case 'danger':
        return 'alert';
      case 'success':
        return 'check-circle';
      case 'warning':
        return 'warning';
      default:
        return 'info';
    }
  });
}
